import React from 'react';

const STATUS_META = {
  pending: {
    label: '확인필요',
    bg: 'rgba(245,158,11,0.12)',
    border: 'rgba(245,158,11,0.35)',
    color: '#b45309',
  },
  included: {
    label: '인센포함',
    bg: 'rgba(37,99,235,0.12)',
    border: 'rgba(37,99,235,0.35)',
    color: '#1d4ed8',
  },
  excluded: {
    label: '인센제외',
    bg: 'rgba(100,116,139,0.14)',
    border: 'rgba(100,116,139,0.32)',
    color: 'var(--text-sub)',
  },
};

export function getDecisionStatus(row) {
  const status = String(row?.incentive_decision_status || '').trim();
  if (STATUS_META[status]) return status;
  return row?.incentive_include_cancelled ? 'included' : 'pending';
}

function buttonStyle(active, disabled) {
  return {
    border: active ? '1px solid #2563eb' : '1px solid var(--border)',
    borderRadius: 7,
    padding: '5px 9px',
    background: active ? '#2563eb' : 'var(--bg-card)',
    color: active ? '#fff' : 'var(--text-sub)',
    fontSize: 12,
    fontWeight: 800,
    cursor: disabled ? 'wait' : 'pointer',
    opacity: disabled ? 0.65 : 1,
    whiteSpace: 'nowrap',
  };
}

function statusChipStyle(status) {
  const meta = STATUS_META[status] || STATUS_META.pending;
  return {
    border: `1px solid ${meta.border}`,
    borderRadius: 999,
    padding: '3px 8px',
    background: meta.bg,
    color: meta.color,
    fontSize: 11,
    fontWeight: 900,
    whiteSpace: 'nowrap',
  };
}

export function DecisionInfo({ row }) {
  const status = getDecisionStatus(row);
  if (status === 'pending') return null;
  const name = row?.incentive_decided_by_name || row?.incentive_decided_by_login_id || '-';
  const at = row?.incentive_decided_at || '-';
  return (
    <span
      title={`처리자: ${name} / 처리일: ${at}`}
      style={{
        fontSize: 11,
        fontWeight: 800,
        color: 'var(--text-muted)',
        whiteSpace: 'nowrap',
      }}
    >
      {name} · {at}
    </span>
  );
}

export function DecisionStatusChip({ row }) {
  const status = getDecisionStatus(row);
  return <span style={statusChipStyle(status)}>{STATUS_META[status]?.label || STATUS_META.pending.label}</span>;
}

export function ContractCancelActions({ row, saving, onToggle }) {
  const status = getDecisionStatus(row);
  const included = status === 'included';
  const excluded = status === 'excluded';
  return (
    <div style={{ display: 'flex', gap: 4, alignItems: 'center', flexShrink: 0, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
      <span style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 800, whiteSpace: 'nowrap' }}>
        인센티브 반영
      </span>
      <span style={statusChipStyle(status)}>{STATUS_META[status]?.label || STATUS_META.pending.label}</span>
      <button
        type="button"
        style={buttonStyle(included, saving)}
        disabled={saving || included}
        onClick={() => onToggle(row, true)}
      >
        포함 처리
      </button>
      <button
        type="button"
        style={buttonStyle(excluded, saving)}
        disabled={saving || excluded}
        onClick={() => onToggle(row, false)}
      >
        제외 처리
      </button>
    </div>
  );
}
